module.exports = __webpack_public_path__ + "static/img/hadReceive.18282d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/task/hadReceive.png
// module id = hl6S
// module chunks = 1